import { useIsEnrolledInVariant } from 'hooks/unleash/useIsEnrolledInVariant';
import { FEATURE_CHECKOUT_STORE_CREDIT } from 'constants/features';
import useMartyContext from 'hooks/useMartyContext';

/**
 *
 * Returns false for 6pm marketplace regardless of feature flag enrollment
 */
export const useStoreCreditEnabled = () => {
  const { marketplace } = useMartyContext();
  const { isEnrolled: isStoreCreditFeatureEnabled } = useIsEnrolledInVariant(FEATURE_CHECKOUT_STORE_CREDIT);

  if (marketplace?.is6pm) {
    return { isStoreCreditEnabled: false };
  }

  return { isStoreCreditEnabled: isStoreCreditFeatureEnabled };
};
